module.exports = __webpack_public_path__ + "media/images/btn_app_store-9548b7a92b144d0282a63f7eb337b576.png";